module.exports = __webpack_public_path__ + "img/gch1.028ececc.png";